module.exports = __webpack_public_path__ + "img/DavidChen.d651991d.png";